import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import MedicationReminders from './components/MedicationReminders';
import DrugInteractionChecker from './components/DrugInteractionChecker';
import PrescriptionRefills from './components/PrescriptionRefills';
import Telepharmacy from './components/Telepharmacy';
import MedicationDelivery from './components/MedicationDelivery';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/medication-reminders" element={<MedicationReminders />} />
        <Route path="/drug-interaction-checker" element={<DrugInteractionChecker />} />
        <Route path="/prescription-refills" element={<PrescriptionRefills />} />
        <Route path="/telepharmacy" element={<Telepharmacy />} />
        <Route path="/medication-delivery" element={<MedicationDelivery />} />
      </Routes>
    </Router>
  );
}

export default App;
